import React from "react";
import { Star } from "@mui/icons-material";

const DefaultStarBadge = ({ isDefault, top = 8, right = 8, size = '24px' }) => {
  if (!isDefault) return null;

  return (
    <Star 
      style={{ 
        position: 'absolute', 
        top, 
        right, 
        color: '#FFC107', 
        zIndex: 10,
        fontSize: size
      }} 
    />
  );
};

export default DefaultStarBadge;

